import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppStateTypes } from '../../../store/appStateTypes';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';
import CheckboxComponent from '../../../core/components/checkbox/CheckboxComponent';
import { textSettingsToggleRandomLineLeftIndentAction } from '../state/actions';

const RandomLineLeftIndentContainer = () => {
  const dispatch = useDispatch();

  const { isRandomLineLeftIndent } = useSelector((state: AppStateTypes) => state.textSettings);

  const onChangeFontSize = (value: boolean) => {
    dispatch(textSettingsToggleRandomLineLeftIndentAction(value));
  };

  return (
        <PanelSubSectionComponent>
            <CheckboxComponent
                defaultValue={isRandomLineLeftIndent}
                onChange={onChangeFontSize}
                title={<p>Разный отступ между словами</p>}
            />
        </PanelSubSectionComponent>
  );
};

export default RandomLineLeftIndentContainer;
